import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'aw-section-headline',
  standalone: true,
  templateUrl: './section-headline.component.html',
})
export class SectionHeadlineComponent {
  public readonly size: InputSignal<'default' | 'medium' | 'small'> = input<
    'default' | 'medium' | 'small'
  >('default');
}
